(function($){
  let classNameActive = 'block_employees__category--active';
  let $catButton = $('.js-employees-tab');

  $catButton.click(function(){
    $(this)
      .toggleClass(classNameActive)
      .next()
        .slideToggle();
  });
  $(document).ready(function(){
    let first = true;
    $catButton.each(function(){
      if ( first ) {
        $(this).addClass(classNameActive);
        first = false;
      }
      else {
        $(this).next().slideUp();
      }
    })
  });
})(jQuery);